import React from 'react';
import { ListedReportMail } from 'helper/mailer';
// import {
//   faFileWord, faFilePdf, faEnvelopeCircleCheck, faSquareCheck, IconDefinition,
// } from '@fortawesome/free-solid-svg-icons';
import Icon from 'components/DesignSystem/Icon';
import { IconType } from 'components/DesignSystem/Icon/icons';
import { Col } from 'react-bootstrap';
import { cssVar } from 'constants/theme';

const iconNameToIcon: { [key: string]: string } = {
  word: 'word',
  pdf: 'pdf',
  email: 'message',
  finished: 'checkmark',
};

const typeToAttribute: { [key: string]: string } = {
  word: 'ckWordGenerated',
  pdf: 'ckPdfGenerated',
  email: 'ckMailGenerated',
  finished: 'ckFinalized',
};

const activatedColor = cssVar('success-solid');
const deactivatedColor = cssVar('text-disabled');
const colorMap = new Map<boolean | null, string>();
colorMap.set(true, activatedColor);
colorMap.set(false, deactivatedColor);
colorMap.set(null, deactivatedColor);

export default function LabelIcon({ report, type }: {
  report: ListedReportMail,
  type: string,
}) {
  const icon: string = iconNameToIcon[type];
  const activated = report.status[0][typeToAttribute[type]];
  const color = colorMap.get(activated);

  return (
    <Col md="2">
      <Icon
        id={`${type}-generated-${report.processId}`}
        iconType={icon as IconType}
        color={color}
        size="large"
      />
    </Col>
  );
}
